import { theme } from "../../utils/theme";

export const styles = {
  bodyText: {
    color: theme.palette.grays["black"],
    fontSize: {
      xs: theme.typography.body3,
      md: theme.typography.body3,
    },
    fontWeight: 600,
    letterSpacing: 0.9,
    mb: 1,
    textAlign: { xs: "center", md: "center" },
    textTransform: "uppercase",
  },
  grow: {
    flexGrow: 1,
    marginLeft: "auto",
  },
  margin: {
    display: "flex",
    margin: theme.spacing(1),
  },
  partnerBrand: {
    alignItems: "center",
    display: "flex",
    filter: "brightness(1) invert(0) grayscale(0.9)",
    height: { xs: 100, sm: 110 },
    opacity: 1,
    transition: "all 0.8s ease-in-out",
    zIndex: 100,
    "&:hover": {
      filter: "brightness(1) grayscale(0)",
      opacity: 1,
    },
  },
};
